import Form from 'components/Profile/PersonalInfo/Form';
import ViewGate from 'components/Profile/View/Gate';

const PersonalInfo = () => {
  return (
    <ViewGate stepId="personal">
      {(editProps) => <Form {...editProps} />}
    </ViewGate>
  )
}

export default PersonalInfo;
